import { MenuData } from "@/lib/types";

export const menuData: MenuData = {
  navMenu: [
    { label: "Home", href: "/", isScroll: false },
    // Projects goes back to the homepage showcase it has always pointed at.
    // Case Study keeps its own entry so the index page is still linked from
    // every page of the site — that is how it gets crawled in the first place.
    { label: "Projects", href: "/#projects", isScroll: true },
    { label: "Case Study", href: "/case-study", isScroll: false },
    { label: "Services", href: "/services", isScroll: false },
    { label: "About", href: "/about-us", isScroll: false },
    { label: "Contact", href: "/contact", isScroll: false },
  ],
  // The footer gets its own list, capped at five.
  //
  // It used to render `navMenu` plus a hardcoded Career link, which made seven
  // entries and meant the footer could never be trimmed without also trimming
  // the header. The header already carries every page on every page, so the
  // footer's job is the conversion path and the two content hubs: Home is the
  // logo, Projects is the same intent as Case Study, and About is one click
  // away in the header.
  footerMenu: [
    { label: "Services", href: "/services", isScroll: false },
    { label: "Case Study", href: "/case-study", isScroll: false },
    { label: "Blogs", href: "/blogs", isScroll: false },
    { label: "Contact", href: "/contact", isScroll: false },
    { label: "Career", href: "/career", isScroll: false },
  ],
  contacts: [
    { label: "hi@octarnal.com", href: "mailto:hi@octarnal.com" },
    { label: "+880-185-202-4152", href: "tel:+880-185-202-4152" },
  ],
  socials: [
    { label: "X link", href: "https://x.com/theOctarnal" },
    { label: "Facebook", href: "https://www.facebook.com/octarnal" },
    { label: "Linkedin", href: "https://www.linkedin.com/company/octarnal/" },
  ],
};
